import { ToastNotifications, randomUUID } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import styled from 'styled-components';

import ErrorBoundary from '../FormTemplates/components/container/ErrorBoundary';
import { CohortsContainer } from './components/container';
import { Account } from './models';
import { setInternalSettings } from './redux/actions';
import store from './redux/store';

function Cohorts(props) {
  const { account, token } = props;

  useEffect(() => {
    const internalValues = {
      account: new Account(account),
      authenticityToken: token,
    };

    store.dispatch(setInternalSettings(internalValues));
  }, []);

  return (
    <Provider store={store}>
      <ErrorBoundary authenticityToken={token} errorRef={randomUUID()}>
        <ToastNotifications />
        <div className="grouping-builder_container">
          <ProviderWrapper className="grouping-builder_content-container">
            <CohortsContainer />
          </ProviderWrapper>
        </div>
      </ErrorBoundary>
    </Provider>
  );
}

const ProviderWrapper = styled.div`
  width: 80%;
`;

Cohorts.propTypes = {
  account: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  token: PropTypes.string.isRequired,
};

export default Cohorts;
